export const breakpoints = {
  xxs: '390px',
  xs: '576px',
  s: '768px',
  m: '992px',
  l: '1200px',
  xl: '1440px',
  xxl: '1600px',
  ul: '1920px',
};